import { render, staticRenderFns } from "./buddingInfoSmall.vue?vue&type=template&id=770f1cca&scoped=true"
import script from "./buddingInfoSmall.vue?vue&type=script&lang=js"
export * from "./buddingInfoSmall.vue?vue&type=script&lang=js"
import style0 from "./buddingInfoSmall.vue?vue&type=style&index=0&id=770f1cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f1cca",
  null
  
)

export default component.exports